import type { User } from '@auth0/auth0-react';
import type { UserProfile } from '../contexts/AuthProvider';


export function getSessionDisplayName(
  auth0User: User | undefined,
  appUser: UserProfile | null,
): string {
  const fromApp = [appUser?.first_name, appUser?.last_name]
    .filter((s): s is string => Boolean(s && String(s).trim()))
    .join(' ')
    .trim();
  if (fromApp.length > 0) {
    return fromApp;
  }

  if (auth0User) {
    const fromParts = [auth0User.given_name, auth0User.family_name]
      .filter((s): s is string => Boolean(s?.trim()))
      .join(' ')
      .trim();
    if (fromParts.length > 0) {
      return fromParts;
    }
    if (auth0User.name?.trim()) {
      return auth0User.name.trim();
    }
  }

  return 'Admin';
}

export function getSessionDisplayEmail(
  auth0User: User | undefined,
  appUser: UserProfile | null,
): string | null {
  const raw = appUser?.email?.trim() || auth0User?.email?.trim();
  return raw || null;
}
